import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { SiteLayout } from "@/components/aranon/SiteLayout";
import { CursorGlow } from "@/components/aranon/CursorGlow";
import Index from "./pages/Index.tsx";

// Lazy-load secondary routes to keep initial JS small (better LCP/FCP).
const Platforms = lazy(() => import("./pages/Platforms.tsx"));
const PlatformDetail = lazy(() => import("./pages/PlatformDetail.tsx"));
const Sectors = lazy(() => import("./pages/Sectors.tsx"));
const SectorDetail = lazy(() => import("./pages/SectorDetail.tsx"));
const HowWeWorkPage = lazy(() => import("./pages/HowWeWorkPage.tsx"));
const Engagement = lazy(() => import("./pages/Engagement.tsx"));
const ImpactPage = lazy(() => import("./pages/ImpactPage.tsx"));
const AboutPage = lazy(() => import("./pages/AboutPage.tsx"));
const ContactPage = lazy(() => import("./pages/ContactPage.tsx"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe.tsx"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <CursorGlow />
        <BrowserRouter>
          <Suspense fallback={null}>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Index />} />
                <Route path="/platforms" element={<Platforms />} />
                <Route path="/platforms/:slug" element={<PlatformDetail />} />
                <Route path="/sectors" element={<Sectors />} />
                <Route path="/sectors/:slug" element={<SectorDetail />} />
                <Route path="/how-we-work" element={<HowWeWorkPage />} />
                <Route path="/engagement" element={<Engagement />} />
                <Route path="/impact" element={<ImpactPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/unsubscribe" element={<Unsubscribe />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
